import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal, Overline, BookButton } from "@/components/bits";
import { PRICES } from "@/lib/site";

const SERVICES = [
  {
    n: "01",
    title: "Førstegangskonsultasjon",
    text: "Ved første besøk starter vi med en grundig samtale om dine plager og din helsehistorie. Deretter gjennomføres en osteopatisk undersøkelse, før behandling tilpasses deg og dine behov.",
  },
  {
    n: "02",
    title: "Oppfølgingstime",
    text: "Ved oppfølging vurderer vi utviklingen siden forrige time og tilpasser den videre behandlingen. Der det er aktuelt, får du råd og øvelser med deg hjem.",
  },
];

export default function Tjenester() {
  return (
    <>
      <Seo
        title="Tjenester | Actus Osteopati – Osteopat Oslo sentrum"
        description="Se våre tjenester ved Actus Osteopati i Oslo sentrum: osteopatisk undersøkelse og behandling av muskel- og skjelettplager. Book time enkelt online."
      />
      <PageHeader
        overline="Actus Osteopati"
        title="Priser"
        testId="tjenester-heading"
      />

      <section data-testid="tjenester-list" className="bg-paper py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <Overline>Dette tilbyr vi</Overline>
          </Reveal>
          <div>
            {SERVICES.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08}>
                <div className="grid md:grid-cols-12 gap-6 py-12 border-t border-ink/10">
                  <h2 className="md:col-span-4 md:col-start-2 font-display font-light text-2xl md:text-3xl leading-tight">{s.title}</h2>
                  <p className="md:col-span-6 md:col-start-7 text-base text-ink-soft leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div data-testid="tjenester-prices" className="mt-12 bg-[#938E7A] px-8 md:px-14 py-12 md:py-16">
              <div className="grid md:grid-cols-12 gap-8">
                <h2 className="md:col-span-4 font-display font-light text-2xl md:text-3xl text-sand">Priser</h2>
                <div className="md:col-span-8">
                  {PRICES.map((p) => (
                    <div key={`${p.name}-${p.duration}`} className="flex items-baseline justify-between gap-4 py-4 border-b border-sand/25 first:pt-0 last:border-b-0 last:pb-0">
                      <div>
                        <p className="text-base md:text-lg text-sand">{p.name}</p>
                        <p className="text-sm text-sand/60">{p.duration}</p>
                      </div>
                      <p className="font-display font-light text-xl md:text-2xl whitespace-nowrap text-sand">{p.price}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-12 flex flex-col md:flex-row md:items-center gap-8 justify-between bg-beige px-8 md:px-12 py-12">
              <p className="text-base md:text-lg text-ink-soft max-w-xl">
                Klar for å bestille? Velg en tid som passer deg i vårt
                bookingsystem.
              </p>
              <BookButton testId="tjenester-book-button" dark label="Book time nå" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
